import { connect } from 'react-redux';
import MeetingRegistery from './MeetingRegistery';
import {
    meetingRegisteries,
    getLoading
} from '../../store/selectors/meeting.selector';
import {
    getMettingsRegistery,
} from '../../store/actions/meetings.actions';

const mapDispatchToProps = {  getMettingsRegistery };

const mapStateToProps = (state) => { 
    const allMeetings = meetingRegisteries(state);
    const loading = getLoading(state);
    return { allMeetings, loading };
 };

export default connect(mapStateToProps, mapDispatchToProps)(MeetingRegistery);